import { Reveal } from '@/components/Reveal';
import { Section } from '@/components/Section';
import { testimonials } from '@/content/site';
import styles from './Testimonials.module.css';

export function Testimonials() {
  return (
    <Section id="testimonials" eyebrow="what clients say" title="The parts they remember" align="center">
      <ul className={styles.grid}>
        {testimonials.map((testimonial, index) => (
          <Reveal as="li" key={testimonial.author} className={styles.card} delay={index * 90}>
            <span className={styles.quoteMark} aria-hidden="true">
              &ldquo;
            </span>
            <blockquote className={styles.quote}>
              <p>{testimonial.quote}</p>
            </blockquote>
            <div className={styles.author}>
              <cite className={styles.name}>{testimonial.author}</cite>
              <span className={styles.role}>{testimonial.role}</span>
            </div>
          </Reveal>
        ))}
      </ul>
    </Section>
  );
}
